export enum CustomerAccountType {
  TradeCredit = 'tradeCredit',
  IHC = 'ihc',
}
